import routerOptions0 from "/usr/src/app/content/n3-promos-17cb3020-d604-412a-8af2-07ef9b564307/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}